import React, {ReactNode} from "react";
import AbstractDialog, {AbstractDialogProperties, AbstractDialogState} from "./AbstractDialog";
import Translate from "../../translation/Translate";
import Icon from "../../components/Icon";
import {Dialog} from "primereact/dialog";
import FunctionHelper from "../../helper/FunctionHelper";

interface ReconnectDialogProperties extends AbstractDialogProperties {
	tries?: number;
}

interface ReconnectDialogState extends AbstractDialogState {
	show: boolean;
}

export class ReconnectDialogDefinition extends AbstractDialog<ReconnectDialogProperties, ReconnectDialogState> {
	constructor(props: Readonly<ReconnectDialogProperties>) {
		super(props);

		this.state = {
			...this.state,
			show: false
		};
	}

	public renderDialog(): ReactNode {
		let tries: number = FunctionHelper.applyValue(this.props.tries, 0);
		let classList: Array<string> = ["reconnect-dialog"];
		if (this.state.submitted) {
			classList.push("submitted");
		}

		if (this.state.show) {
			classList.push("visible");
		}

		return (
			<Dialog className={classList.join(" ")} visible={this.props.visible} onHide={this.hide}
					closeOnEscape={false} header={this.renderHeader()} footer={<div/>} resizable={false}
					appendTo={document.getElementById("root")}>
				<div className="p-grid">
					{this.renderError()}
					<fieldset className="p-col-12 p-grid">
						<div className="p-col-12 p-grid" style={{flexWrap: "nowrap"}}>
							<div className="p-col-fixed" style={{position: "relative"}}>
								<Icon icon={"icon-spinner spin"} position={"left"}/>
								{tries > 0 &&
									<p className="reconnect-label">
										<Translate {...this.props} data="reconnect.try" namespace="dialog"
												   values={{
													   try: tries
												   }}/>
									</p>
								}
							</div>
							<div className="p-col" style={{width: 0}}>
								<div className="dialog-message">
									<Translate {...this.props} data="reconnect.message" namespace="dialog"/>
								</div>
							</div>
						</div>
					</fieldset>
				</div>
			</Dialog>
		);
	}

	protected async onShow(): Promise<void> {
		super.onShow();

		this.setState({
			show: true
		});
	}

	protected renderHeader(): ReactNode {
		return (
			<div>
				<h1>
					<Icon icon={"icon-reload"}/>
					<Translate {...this.props} data="reconnect.title" namespace="dialog"/>
				</h1>
			</div>
		);
	}

	protected isValid(): boolean {
		return false;
	}
}

const ReconnectDialog = React.memo(ReconnectDialogDefinition,
	(prevProps: Readonly<ReconnectDialogProperties>, nextProps: Readonly<ReconnectDialogProperties>) => {
		if (!nextProps.visible && !prevProps.visible) {
			return true
		}

		return false;
	}
);

export default ReconnectDialog;